import { module } from "angular";
import searchCore from "@gtmhub/search/search-core.module";
import usersSelector from "@gtmhub/shared/components/users-selector/users-selector.module";
import { BadgeAwardListComponent } from "@webapp/badges/components/badge-award-list/badge-award-list.component";
import badgesCore from "./badges-core.module";
import { BadgesTopNavBarComponent } from "./components/badges-top-nav-bar/badges-top-nav-bar.component";
import { UserBadgesDetailsComponent } from "./components/user-badges-details/user-badges-details.component";
import { ApproveBadgesCtrl } from "./controllers/approve";
import { AwardBadgeCtrl } from "./controllers/award";
import { BadgeCtrl } from "./controllers/badge";
import { BadgesCtrl } from "./controllers/badges";
import { BadgeFormCtrl } from "./controllers/form";
import { BadgeTemplatesCtrl } from "./controllers/templates";
import { AnnouncementService } from "./services/announcements.service";
import { BadgesModalsService } from "./services/badgesModals";
import { Ng1ConfirmBadgeActionService } from "./services/ng1-confirm-badge-action.service";

const mod = module("badges", [badgesCore, searchCore, usersSelector]);

mod.controller("ApproveBadgesCtrl", ApproveBadgesCtrl);
mod.controller("BadgeCtrl", BadgeCtrl);
mod.controller("BadgesCtrl", BadgesCtrl);
mod.controller("AwardBadgeCtrl", AwardBadgeCtrl);
mod.controller("BadgeFormCtrl", BadgeFormCtrl);
mod.controller("BadgeTemplatesCtrl", BadgeTemplatesCtrl);
mod.service("BadgesModalsService", BadgesModalsService);
mod.component("userBadgesDetails", UserBadgesDetailsComponent);
mod.downgradeComponent("ghBadgeAwardList", { component: BadgeAwardListComponent, propagateDigest: false });
mod.component("badgesTopNavBar", BadgesTopNavBarComponent);
mod.service("AnnouncementService", AnnouncementService);
mod.service("Ng1ConfirmBadgeActionService", Ng1ConfirmBadgeActionService);

export default mod.name;
